import * as React from 'react'
import {
  Container,
  Title,
  WrapperContainerBar,
  ContainerBar,
  Message,
  CurrentLoad,
  Fill
} from './LoadCapacityPercentageBar.styles'
import { usePercentageBarConfig } from '../../hooks/usePercentageBarConfig'

type SimplePercentageBarProps = {
  percentage: number
}

const SimplePercentageBar: React.FC<SimplePercentageBarProps> = ({
  percentage
}) => {
  const { color, message } = usePercentageBarConfig(percentage)
  return (
    <Container>
      <Title>Fill Percentage</Title>
      <WrapperContainerBar>
        <ContainerBar>
          <Fill $percentage={percentage} $color={color} />
        </ContainerBar>
        <CurrentLoad>{percentage}%</CurrentLoad>
      </WrapperContainerBar>
      <Message>{message}</Message>
    </Container>
  )
}

export default SimplePercentageBar
